<template>
  <div>
    <h1 class="page-header">{{ $t('corporatepartner.corporatePartner') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label>{{ $t('corporatepartner.nameKh') }}</label>
              <input
                v-model="model.partner_name_kh"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('partner_name_kh') }"
                :placeholder="$t('corporatepartner.enterCorporateParnerInKh')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('partner_name_kh')"
              >
                {{ errors.first('partner_name_kh') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('corporatepartner.nameEn')
              }}</label>
              <input
                v-model="model.partner_name_en"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('partner_name_en') }"
                :placeholder="$t('corporatepartner.enterCorporateParnerInEn')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('partner_name_en')"
              >
                {{ errors.first('partner_name_en') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('corporatepartner.contactNo')
              }}</label>
              <input
                v-model="model.contact_no"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('contact_no') }"
                :placeholder="$t('corporatepartner.enterContactNumber')"
              />
              <div class="invalid-feedback" v-if="errors.has('contact_no')">
                {{ errors.first('contact_no') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('corporatepartner.discountRate') }}</label>
              <input
                v-model.number="model.discount_rate"
                type="number"
                step="any"
                class="form-control"
                :class="{ 'is-invalid': errors.has('discount_rate') }"
                :placeholder="$t('corporatepartner.enterRate')"
              />
              <div class="invalid-feedback" v-if="errors.has('discount_rate')">
                {{ errors.first('discount_rate') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>{{ $t('corporatepartner.address') }}</label>
              <textarea
                v-model="model.partner_address"
                class="form-control"
                :class="{ 'is-invalid': errors.has('partner_address') }"
                rows="2"
                :placeholder="
                  $t('corporatepartner.enterCorporatePartnerAddress')
                "
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('partner_address')"
              >
                {{ errors.first('partner_address') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import DataTable from './table'

export default {
  name: 'corporate-partner-form',
  components: {
    DataTable
  },
  data() {
    return {
      fetch: false,
      waiting: false,
      updating: false,
      errors: new Errors(),
      model: {
        cpp_id: '',
        partner_name_kh: '',
        partner_name_en: '',
        partner_address: '',
        contact_no: '',
        discount_rate: ''
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('corporatePartner', ['edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('corporatePartner/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('corporatePartner/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    clearInput() {
      this.model = {
        cpp_id: '',
        partner_name_kh: '',
        partner_name_en: '',
        partner_address: '',
        contact_no: '',
        discount_rate: ''
      }
    },
    cancel() {
      this.updating = false
      this.$store.commit('corporatePartner/SET_EDIT_DATA', {})
      this.$router.push({ name: 'corporate-partner' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('corporatePartner/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetchData = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('corporatePartner/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
